<hpf-marker-form
        *ngIf="marker"
        [marker]="marker"
        (create)="onCreate($event)"
    ></hpf-marker-form>
<div *ngIf="!marker" class="my-5 text-center">
    <nz-spin nzSimple></nz-spin>
</div>